<template>
  <div style="margin: 0 -15px">
    <div style="padding: 10px 20px" class="distanceLabel">
      <el-form
        ref="editFormRef"
        :model="editForm"
        label-position="top"
        size="small"
      >
        <el-row :gutter="10">
          <el-col :span="12">
            <!-- 限制的问题件原因 -->
            <el-form-item
              :label="$t('navbar.ReasonForLimitedProblems')"
              prop="problemTypeIds"
              :rules="[{ required: true, message: $t('GlobalSetObj.required'), trigger: ['blur', 'change'] }]"
            >
              <el-select
                v-model="editForm.problemTypeIds"
                multiple
                :placeholder="$t('collectionCenter.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in otherReasonList"
                  :key="item.problemId"
                  :label="item.dictDescribe"
                  :value="item.problemId"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 限制的州  -->
            <el-form-item
              :label="$t('navbar.restrictionState')"
              prop="stateList"
              :rules="[{ required: true, message: $t('GlobalSetObj.required'), trigger: ['blur', 'change'] }]"
            >
              <el-select
                v-model="editForm.stateList"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                multiple
                style="width: 100%"
                @clear="clearSelect('stateList', stateListOption)"
                @remove-tag="(value) => removeMerchant(value, 'stateList', stateListOption)"
              >
                <el-option
                  v-show="stateListOption.length > 0"
                  :label="$t('collectionCenter.tudo')"
                  :value="-1"
                  @click.native.stop="toggleSelectAll('stateList', stateListOption)"
                />
                <el-option
                  v-for="item in stateListOption"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.disabled"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--限制的网点-->
            <el-form-item
              :label="$t('navbar.restrictionSiteId')"
              prop="siteIds"
              :rules="[{ required: true, message: $t('GlobalSetObj.required'), trigger: ['blur', 'change'] }]"
            >
              <el-select
                v-model="editForm.siteIds"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                multiple
                remote
                reserve-keyword
                :remote-method="handleStateList"
                style="width: 100%"
                @visible-change="openHandleStateList"
                @clear="clearSelect('siteIds', siteListOption)"
                @remove-tag="(value) => removeMerchant(value, 'siteIds', siteListOption)"
              >
                <el-option
                  v-show="siteListOption.length > 0"
                  :label="$t('collectionCenter.tudo')"
                  :value="-1"
                  @click.native.stop="toggleSelectAll('siteIds', siteListOption)"
                />
                <el-option
                  v-for="item in siteListOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.disabled"
                  @click.native.stop="selectSite('siteIds', siteListOption)"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--限制的账号-->
            <el-form-item
              :label="$t('navbar.RestrictedAccounts')"
              prop="userIds"
              :rules="[{ required: true, message: $t('GlobalSetObj.required'), trigger: ['blur', 'change'] }]"
            >
              <el-select
                v-model="editForm.userIds"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                multiple
                remote
                reserve-keyword
                :remote-method="getAllUserList"
                style="width: 100%"
                @visible-change="openUserList"
                @clear="clearSelect('userIds', accountList)"
                @remove-tag="(value) => removeMerchant(value, 'userIds', accountList)"
              >
                <el-option
                  v-show="accountList.length > 0"
                  :label="$t('collectionCenter.tudo')"
                  :value="-1"
                  @click.native.stop="toggleSelectAll('userIds', accountList)"
                />
                <el-option
                  v-for="item in accountList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.disabled"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--客户-->
            <el-form-item
              :label="$t('GlobalSetObj.client')"
              prop="customerIds"
              :rules="[{ required: true, message: $t('GlobalSetObj.required'), trigger: ['blur', 'change'] }]"
            >
              <el-select
                v-model="editForm.customerIds"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                multiple
                remote
                reserve-keyword
                :remote-method="getCustomerPage"
                style="width: 100%"
                @visible-change="openCustomerPage"
                @change="changeCustomer"
                @clear="clearSelect('customerIds', customerOption)"
                @remove-tag="(value) => removeMerchant(value, 'customerIds', customerOption)"
              >
                <el-option
                  v-show="customerOption.length > 0"
                  :label="$t('collectionCenter.tudo')"
                  :value="-1"
                  @click.native.stop="toggleSelectAll('customerIds', customerOption)"
                />
                <el-option
                  v-for="item in customerOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.disabled"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--商户-->
            <el-form-item
              :label="$t('collectionCenter.CommercialOwner')"
              prop="merchantCodes"
              :rules="[{ required: true, message: $t('GlobalSetObj.required'), trigger: ['blur', 'change'] }]"
            >
              <el-select
                v-model="editForm.merchantCodes"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                multiple
                remote
                reserve-keyword
                :remote-method="getMerchantList"
                style="width: 100%"
                @visible-change="openMerchantList"
                @clear="clearSelect('merchantCodes', merchantOption)"
                @remove-tag="(value) => removeMerchant(value, 'merchantCodes', merchantOption)"
              >
                <el-option
                  v-show="merchantOption.length > 0"
                  :label="$t('collectionCenter.tudo')"
                  :value="-1"
                  @click.native.stop="toggleSelectAll('merchantCodes', merchantOption)"
                />
                <el-option
                  v-for="item in merchantOption"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.disabled"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--问题件登记距离(M)-->
            <el-form-item
              :label="$t('navbar.ProblemRegistrationDistance') + '(M)'"
              prop="mustDistance"
              style="display: inline-block;width: 50%;"
              :rules="[{ required: true, message: $t('GlobalSetObj.required'), trigger: ['blur', 'change'] }]"
            >
              <el-select
                v-model="editForm.mustDistance"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
                @change="changeDistance"
              >
                <el-option :key="1" :label="$t('GlobalSetObj.yes')" :value="1" />
                <el-option :key="2" :label="$t('GlobalSetObj.No')" :value="0" />
              </el-select>
            </el-form-item>
            <!--问题件登记距离(M)-->
            <el-form-item
              v-if="editForm.mustDistance === 1"
              label=""
              prop="distance"
              style="display: inline-block;width: 50%;"
              :rules="[{ required: true, validator: distanceRules, trigger: ['blur', 'change'] }]"
            >
              <el-input
                v-model="editForm.distance"
                :placeholder="$t('GlobalSetObj.pleaseInput')"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--强制提供照片-->
            <el-form-item
              :label="$t('navbar.ForcePhoto')"
              prop="mustPic"
              :rules="[{ required: true, message: $t('GlobalSetObj.required'), trigger: ['blur', 'change'] }]"
            >
              <el-select
                v-model="editForm.mustPic"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option :key="1" :label="$t('GlobalSetObj.yes')" :value="1" />
                <el-option :key="2" :label="$t('GlobalSetObj.No')" :value="0" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="text-align: right;padding: 10px 20px">
      <el-button size="small" @click="clickCancel">{{ $t('GlobalSetObj.cancel') }}</el-button>
      <el-button size="small" type="primary" @click="clickSubmit">{{ $t('GlobalSetObj.confirm') }}</el-button>
    </div>
  </div>
</template>
<script>
import { getLgAreaListData } from '@/api/orderApi';
import { siteFuzzyQuery } from '@/api/lanshou';
import { apiCustomerPage } from '@/api/customer';
import {
  addProblemLimit,
  getProblemLimitPmUserList,
  getProblemLimitUserList,
  updateProblemLimit
} from '@/api/resources';
// import { getSiteByStateAndTypeApi } from '@/api/definiteResponsibilityAndPenalty';
export default {
  name: 'CollectionCenter',
  props: {
    editSiteObject: {
      type: Object,
      default: () => {}
    },
    otherReasonList: {
      type: Array,
      default: () => []
    },
    editDataForm: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    const distanceRules = (rule, value, callback) => {
      // 正则表达式：匹配 0-99999999.99 的数字
      const regex = /^(?:[1-9]\d{0,7}(?:\.\d{1,2})?|0(?:\.\d{1,2})?|99999999(?:\.0{1,2})?)$/;
      if (value === '' || value === null || value === undefined) {
        callback(new Error(this.$t('GlobalSetObj.required')));
      } else {
        // 检查输入是否符合规则
        if (regex.test(value)) {
          callback(); // 输入合法
        } else {
          callback(new Error(this.$t('navbar.OnlyNumbers0To99999999d99CanBeEntered'))); // 输入不合法
        }
      }
    };
    return {
      editForm: {
        id: null,
        problemTypeIds: [], // 限制的问题件原因
        stateList: [], // 限制的州
        siteIds: [], // 限制的网点
        userIds: [], // 限制的账号
        customerIds: [], // 客户
        merchantCodes: [], // 商户
        mustDistance: null, // 是否必填距离
        distance: null, // 距离
        mustPic: null // 是否必填图片
      },
      stateListOption: [], // 州选项
      siteListOption: [], // 网点选项
      customerOption: [], // 客户选项
      accountList: [], // 账号选项
      merchantOption: [], // 商户选项
      isAllSelectedUserIds: false, // 是否全选账号
      isAllSelectedCustomerIds: false, // 是否全选客户
      isAllSelectedMerchantCodes: false, // 是否全选商户
      isAllSelectedSiteIds: false, // 是否全选网点
      isAllSelectedStateList: false, // 是否全选州
      distanceRules
    };
  },
  created() {
    this.editForm = JSON.parse(JSON.stringify(this.editSiteObject));
    console.log(this.editForm, '===editForm===');
    console.log(this.editDataForm, '====editDataForm==');
    if (this.editForm.id !== null && this.editForm.id !== undefined && this.editForm.id !== '') {
      if (this.editForm.userIds.includes(-1)) {
        this['isAllSelectedUserIds'] = true; // 是否全选账号
      } else {
        this['isAllSelectedUserIds'] = false; // 是否全选账号
        this.getAllUserList('', this.editForm.userIds);
      }
      if (this.editForm.customerIds.includes(-1)) {
        this['isAllSelectedCustomerIds'] = true; // 是否全选客户
      } else {
        this['isAllSelectedCustomerIds'] = false; // 是否全选客户
        this.getCustomerPage('', this.editForm.customerIds);
      }
      if (this.editForm.merchantCodes.includes(-1)) {
        this['isAllSelectedMerchantCodes'] = true; // 是否全选商户
      } else {
        this['isAllSelectedMerchantCodes'] = false; // 是否全选商户
        this.getMerchantList('', this.editForm.merchantCodes);
      }
      if (this.editForm.siteIds.includes(-1)) {
        this['isAllSelectedSiteIds'] = true; // 是否全选网点
      } else {
        this['isAllSelectedSiteIds'] = false; // 是否全选网点
        if (this.editDataForm.siteList && this.editDataForm.siteList.length > 0) {
          this.editDataForm.siteList.map(item => {
            item.label = item.siteName;
            item.value = item.siteId;
          });
        }
        this.siteListOption = this.editDataForm.siteList || [];
        console.log(this.siteListOption, '===this.siteListOption');
      }
    }
    this.getAddress();
    // this.handleStateList();
  },
  methods: {
    // 删除已选择的单个选中项
    removeMerchant(val, field, optionList) {
      if (val === -1) { // 如果删除的选项是全部选项 是否全选改为false,并将选项全部取消禁用
        const fieldStr = field.charAt(0).toUpperCase() + field.slice(1);
        this[`isAllSelected${fieldStr}`] = false;
        this.editForm[field] = [];
        optionList.map(item => {
          item.disabled = false;
        });
      }
    },
    // 清除州、网点、账号、客户、商户的已选
    clearSelect(field, optionList) {
      const fieldStr = field.charAt(0).toUpperCase() + field.slice(1);
      // 是否全选改为false,并将选项全部取消禁用
      this[`isAllSelected${fieldStr}`] = false;
      this.editForm[field] = [];
      optionList.map(item => {
        item.disabled = false;
      });
    },
    // 问题件距离变化
    changeDistance() {
      this.editForm.distance = null;
    },
    // 取消
    clickCancel() {
      this.$emit('closeDialog', 0);
    },
    // 确定提交
    clickSubmit() {
      this.$refs.editFormRef.validate(valid => {
        if (!valid) {
          return;
        }
        if (this.editForm.id === null || this.editForm.id === undefined || this.editForm.id === '') {
          // 新增
          addProblemLimit(this.editForm).then(res => {
            if (res.code === 200) {
              this.$message({
                message: this.$t('GlobalSetObj.TheOperationSucceeded'), // '添加成功'
                type: 'success'
              });
              this.$emit('closeDialog', 1);
            }
          });
        } else {
          // 修改
          updateProblemLimit(this.editForm).then(res => {
            if (res.code === 200) {
              this.$message({
                message: this.$t('GlobalSetObj.TheOperationSucceeded'), // '更新成功'
                type: 'success'
              });
              this.$emit('closeDialog', 1);
            }
          });
        }
      });
    },
    // 通用全选/取消全选方法  选中全部 禁用其他选项，取消选中全部 启用其他选项
    toggleSelectAll(field, optionList) {
      const fieldStr = field.charAt(0).toUpperCase() + field.slice(1);
      const isSelectedAll = this[`isAllSelected${fieldStr}`];
      this[`isAllSelected${fieldStr}`] = !isSelectedAll;
      if (this[`isAllSelected${fieldStr}`]) {
        // 全选：将所有选项加入选中列表
        this.editForm[field] = [-1];
        optionList.map(item => {
          item.disabled = true;
        });
      } else {
        // 取消全选：清空选中列表
        this.editForm[field] = [];
        optionList.map(item => {
          item.disabled = false;
        });
      }
      // 选择网点将网点所属州赋值给州选项
      if (field === 'siteIds') {
        if (this.editForm['stateList'].includes(-1) === false) { // 如果州选项没有全选
          if (this.editForm[field].includes(-1) === false) { // 如果网点选项没有全选
            const siteListArr = [];
            optionList.map(list => {
              this.editForm[field].map(item => {
                if (item === list.value) {
                  siteListArr.push(list.state);
                }
              });
            });
            this.editForm['stateList'] = [...new Set([...this.editForm['stateList'], ...siteListArr])];
          } else {
            // const siteListArr = [];
            // optionList.map(list => {
            //   siteListArr.push(list.state);
            // });
            // this.editForm['stateList'] = [...new Set([...this.editForm['stateList'], ...siteListArr])];
            this.stateListOption.map(list => {
              list.disabled = true;
            });
            this['isAllSelectedStateList'] = true;
            this.editForm['stateList'] = [-1];
          }
        }
      }
    },
    // 点击网点选择将网点所属州赋值给州选项
    selectSite(field, optionList) {
      if (this.editForm['stateList'].includes(-1) === false) {
        const siteListArr = [];
        optionList.map(list => {
          this.editForm[field].map(item => {
            if (item === list.value) {
              siteListArr.push(list.state);
            }
          });
        });
        this.editForm['stateList'] = [...new Set([...this.editForm['stateList'], ...siteListArr])];
      }
    },
    // 获取所有已启用用户
    getAllUserList(name = '', userIdList = []) {
      const param = {
        pageNumber: 1,
        pageSize: 20,
        params: {
          userName: name,
          accountState: 1,
          ids: userIdList
        }
      };
      getProblemLimitPmUserList(param).then((response) => {
        if (response.code === 200) {
          this.accountList = response.data.records.map(item => {
            return {
              label: item.username,
              value: item.id,
              disabled: this.editForm.userIds.includes(-1)
            };
          });
        }
      });
    },
    // 打开用户选项弹窗
    openUserList(val) {
      if (val) {
        this.getAllUserList('');
      }
    },
    // 州
    getAddress() {
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.stateListOption = res.data.map((item) => {
            return {
              id: item.id,
              label: item.nameEn,
              value: item.nameEn,
              disabled: this.editForm.stateList.includes(-1)
            };
          });
        }
      });
    },
    // 网点选项窗口展开
    openHandleStateList(val) {
      if (val) {
        this.handleStateList();
      }
    },
    // 获取网点
    handleStateList(val = '') {
      // const param = {
      //   stateList: [],
      //   siteBusinessType: 1,
      //   regionIds: []
      // };
      // getSiteByStateAndTypeApi(param).then((res) => {
      //   if (res.code === 200) {
      //     this.siteListOption = res.data.map(item => {
      //       return {
      //         label: item.name,
      //         value: item.id,
      //         state: item.state,
      //         disabled: this.editForm.siteIds.includes(-1)
      //       };
      //     });
      //   }
      // });
      siteFuzzyQuery(val, 1).then((res) => {
        if (res.code === 200) {
          this.siteListOption = res.data.map(item => {
            return {
              label: item.name,
              value: item.id,
              state: item.state,
              disabled: this.editForm.siteIds.includes(-1)
            };
          });
        }
      });
    },
    // 获取已启用客户
    getCustomerPage(name = '', customerIdList = []) {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          quickSearch: name,
          auditState: 1,
          customerIdList
        }
      };
      apiCustomerPage(param).then((res) => {
        if (res.code === 200) {
          this.customerOption = res.data.records.map(item => {
            return {
              label: item.username,
              value: item.id,
              disabled: this.editForm.customerIds.includes(-1)
            };
          });
        }
      });
    },
    // 打开客户选项弹窗
    openCustomerPage(val) {
      if (val) {
        this.getCustomerPage();
      }
    },
    // 获取已启用商户
    getMerchantList(name = '', merchantCodes = []) {
      if (this.editForm.customerIds.length === 0) {
        this.merchantOption = [];
        return;
      }
      let customerIds = [];
      if (this.editForm.customerIds.includes(-1)) {
        customerIds = [];
      } else {
        customerIds = this.editForm.customerIds;
      }
      const data = {
        pageSize: 20,
        pageNumber: 1,
        params: {
          merchantName: name,
          customerIds,
          merchantCodes
        }
      };
      getProblemLimitUserList(data).then((res) => {
        if (res.code === 200) {
          this.merchantOption = res.data.records.map(item => {
            return {
              label: item.merchantName,
              value: item.merchantCode,
              id: item.id,
              disabled: this.editForm.merchantCodes.includes(-1)
            };
          });
        }
      });
    },
    // 商户选项弹窗打开
    openMerchantList(val) {
      if (val) {
        this.getMerchantList();
      }
    },
    // 客户选项变化
    changeCustomer() {
      this.getMerchantList();
      this.editForm.merchantCodes = [];
      this['isAllSelectedMerchantCodes'] = false; // 商户是否选中全部
    }
  }
};
</script>
<style>
.distanceLabel .el-form--label-top .el-form-item__label {
  white-space: nowrap !important;
}
</style>
